import tagularModule from 'js/store/helpers/tagular'

const footerCategories = document.querySelectorAll(
  '[data-js-selector="global-footer-category"]'
)

// Click tracking for links inside footer
if (footerCategories) {
  footerCategories.forEach(category => {
    const footerLinks = category.querySelectorAll('li a.global-footer__link')
    footerLinks.forEach((link, i) => {
      const label = link.innerHTML.trim()
      const webElement = {
        elementType: 'link',
        location: 'footer',
        position: `${++i}`,
        text: label,
        name: 'footer links'
      }

      link.addEventListener('click', () => {
        tagularModule.elementClicked(webElement, `link to ${label}`)
      })
    })
  })
}
